import { useEffect } from 'react'

export const useFavicon = () => {
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

    const updateFavicon = (isDark: boolean) => {
      const link = document.querySelector(
        "link[rel~='icon']",
      ) as HTMLLinkElement
      if (link) {
        link.href = isDark ? '/napsterFav.ico' : '/NapsterLogoBlack.ico'
      }
    }

    updateFavicon(mediaQuery.matches)

    const handler = (e: MediaQueryListEvent) => updateFavicon(e.matches)
    mediaQuery.addEventListener('change', handler)

    return () => mediaQuery.removeEventListener('change', handler)
  }, [])
}
